<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import DialogModal from "@/Components/DialogModal.vue";
import FrontendMediaUpload from "@/Components/Common/Media/FrontendMediaUpload.vue";
import { useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { ref, watch } from "vue";
import { usePage } from "@inertiajs/inertia-vue3";

const page = usePage();

const showUploadModal = ref(false);
const mediaFiles = ref([]);
const form = useForm({ media: [] });
const media = ref(page.props.value.media);
const initialImages = ref(media.value.map(item => ({
  file_name: item.file_name,
  type: 'I',
  url: item.url,
  imageId: item.id,
})));

const updateMedia = (files) => {
  mediaFiles.value = files.I;
  form.media = files.I.map(f => f.file);
};

const save = () => {
  const formData = new FormData();
  mediaFiles.value.forEach(file => {
    formData.append('media[]', file.file);
  });

  Inertia.post(route("admin.measurement-media.store"), formData, {
    preserveScroll: true,
    forceFormData: true, 
    onSuccess: () => {
      showUploadModal.value = false;
      form.reset();
      mediaFiles.value = [];
      Inertia.reload({ only: ['media'] });
      Inertia.visit(route('admin.measurements.index'), {
        preserveScroll: true,
        only: ['media'],
      });
    },
  });
};

const deleteMedia = (mediaItem, onSuccess, onError) => {
  Inertia.delete(route("admin.measurement-media.destroy", mediaItem.imageId), {
    preserveScroll: true,
    onSuccess: () => {
      const updated = media.value.filter(item => item.id !== mediaItem.imageId);
      media.value = updated;
      initialImages.value = updated.map(item => ({
        file_name: item.file_name,
        type: 'I',
        url: item.url,
        imageId: item.id,
      }));
      if (onSuccess) onSuccess();
    },
    onError: () => {
      if (onError) onError();
    }
  });
};

watch(mediaFiles, (newFiles) => {
  form.media = newFiles.map(file => file.file);
});


</script>

<template>
  <AppLayout title="Measurement Media">
    <template #header>
      <div class="flex justify-between items-center">
        <h2 class="font-semibold text-xl text-gray-800 leading-tight">
          Measurement Media
        </h2>
        <button
          @click="showUploadModal = true"
          class="px-4 py-2 bg-gray-800 text-white rounded hover:bg-grey-600"
        >
          Add or Delete Images
        </button>
      </div>

      <div class="p-4">
        <div class="grid grid-cols-1 gap-4">
          <div v-for="image in media" :key="image.id" class="relative w-full p-1">
            <img
              :src="image.url"
              class="w-full h-auto rounded shadow object-cover p-2"
              :alt="image.file_name"
            />
          </div>
        </div>
      </div>

    </template>

    <DialogModal :show="showUploadModal" @close="showUploadModal = false" max-width="4xl">
      <template #title>
        Upload Measurement Media
      </template>

      <template #content>
        <div class="mt-4">
          <FrontendMediaUpload
            :initial-files="{ I: initialImages, F: [] }"
            @update="updateMedia"
            @delete="deleteMedia"
            :can-see-upload-form="true"
            :can-modify-media-details="true"
            :hide-save="false"
            :hide-files="true"
          />

        </div>
      </template>

      <template #footer>
        <button
          class="mr-2 px-4 py-2 bg-gray-300 text-gray-700 rounded"
          @click="showUploadModal = false"
          :disabled="form.processing"
        >
          Cancel
        </button>
        <button
          class="px-4 py-2 bg-gray-800 text-white rounded"
          @click="save"
          :disabled="form.processing"
        >
          Save new images
        </button>
      </template>
    </DialogModal>
  </AppLayout>
</template>
